import angular from 'angular';
import PsychNoteMySettings from 'shared-assets/psychotherapy-notes-ui/components/Settings/PsychNoteMySettings';

angular
  .module('kareo.ui.shared.directives.psych-note-my-settings', ['react'])
  .directive('psychNoteMySettings', psychNoteMySettings);

psychNoteMySettings.$inject = ['reactDirective'];

function psychNoteMySettings(reactDirective) {
  return reactDirective(PsychNoteMySettings);  
}
